import type { SuspensionObject } from 'open-modules/zdf/component/suspension/suspension';
import { SuspensionStatusType } from 'open-modules/zdf/component/suspension/suspension';
import { componentWithVariants, demoFile, variant } from 'system/demo';

import { WarnBlockDisplay } from '../account-warn-block-overview';

demoFile('open-modules/zdf/feature/account/account-warn-block-overview');

const userSuspensionMap: Record<string, SuspensionObject> = {
    1: {
        key: '1',
        time: 1000000000,
        recipientKey: 'a',
        suspensionType: SuspensionStatusType.WARNED,
    },
    2: {
        key: '2',
        time: 2000000000,
        recipientKey: 'a',
        suspensionType: SuspensionStatusType.WARNED,
    },
    3: {
        key: '3',
        time: 3000000000,
        recipientKey: 'a',
        suspensionType: SuspensionStatusType.BLOCKED,
    },
    4: {
        key: '4',
        time: 4000000000,
        recipientKey: 'a',
        suspensionType: SuspensionStatusType.UNBLOCKED,
    },
};

componentWithVariants('Warn and Block Variants', WarnBlockDisplay, {}, [
    variant('No suspension', {}),
    variant('With suspension', {
        state: {
            moduleUserReadGlobal: {
                suspension: {
                    suspensions: userSuspensionMap,
                },
            },
        },
    }),
]);
